var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.3772,
    r: 13.5293,
    fill: "url(#paint0_linear_4229_8413)",
    stroke: "url(#paint1_linear_4229_8413)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0902 9.24083V20.8772H8.28338V11.8658H8.2152L5.61293 13.4567V11.0249L8.48224 9.24083H11.0902ZM18.4751 21.1613C17.46 21.1613 16.585 20.9208 15.8501 20.4397C15.1153 19.9548 14.549 19.2598 14.1513 18.3545C13.7536 17.4454 13.5566 16.3526 13.5604 15.0761C13.5642 13.7995 13.763 12.7162 14.157 11.8261C14.5547 10.9321 15.1191 10.2522 15.8501 9.78629C16.585 9.31659 17.46 9.08174 18.4751 9.08174C19.4903 9.08174 20.3653 9.31659 21.1001 9.78629C21.8388 10.2522 22.407 10.9321 22.8047 11.8261C23.2024 12.72 23.3994 13.8033 23.3956 15.0761C23.3956 16.3564 23.1967 17.4511 22.799 18.3602C22.4013 19.2692 21.835 19.9643 21.1001 20.4454C20.3691 20.9227 19.4941 21.1613 18.4751 21.1613ZM18.4751 18.8602C19.0812 18.8602 19.5717 18.5514 19.9467 17.934C20.3217 17.3128 20.5073 16.3602 20.5036 15.0761C20.5036 14.2352 20.4183 13.542 20.2479 12.9965C20.0774 12.4473 19.8407 12.0382 19.5376 11.7692C19.2346 11.5003 18.8804 11.3658 18.4751 11.3658C17.8729 11.3658 17.3861 11.6708 17.0149 12.2806C16.6437 12.8867 16.4562 13.8185 16.4524 15.0761C16.4486 15.9283 16.5301 16.6348 16.6967 17.1954C16.8672 17.756 17.1058 18.1745 17.4126 18.4511C17.7195 18.7238 18.0736 18.8602 18.4751 18.8602Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4229_8413",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3E52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4229_8413",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11273D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank10);
export default __webpack_public_path__ + "static/media/rank10.e39989697ede4adb40458683cab792a1.svg";
export { ForwardRef as ReactComponent };